export const USER_SURNAME_REGEX = /^$|^[a-zA-Zа-яА-Я]+(-?[a-zA-Zа-яА-Я])*$/;
export const USER_NAME_REGEX = /^$|^[a-zA-Zа-яА-Я]+$/;
export const USER_NAME_ERROR = 'Имя пользователя может содержать только латинские буквы или кириллицу';
